'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require('./style/terms.css') : void 0;

var _nuiWidgets = require('@concur/nui-widgets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermsPanel = function (_React$Component) {
  _inherits(TermsPanel, _React$Component);

  function TermsPanel() {
    _classCallCheck(this, TermsPanel);

    return _possibleConstructorReturn(this, (TermsPanel.__proto__ || Object.getPrototypeOf(TermsPanel)).apply(this, arguments));
  }

  _createClass(TermsPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showCheckbox = _props.showCheckbox,
          checked = _props.checked,
          onChange = _props.onChange,
          title = _props.title,
          description = _props.description,
          checkboxId = _props.checkboxId;


      var showCheckboxStyle = {
        display: showCheckbox ? 'inline' : 'none'
      };

      var tAndCTitle = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 't-and-c-title' },
          title
        ),
        _react2.default.createElement(
          'p',
          { className: 't-and-c-description' },
          _react2.default.createElement(
            'span',
            null,
            description
          )
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'term-item-and-box checkbox' },
        _react2.default.createElement('input', {
          id: checkboxId,
          type: 'checkbox',
          checked: checked,
          onChange: onChange,
          style: showCheckboxStyle
        }),
        _react2.default.createElement(
          _nuiWidgets.SectionExpandable,
          {
            expanded: false,
            title: tAndCTitle,
            headingLevel: 'h3'
          },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'terms-panel-children' },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return TermsPanel;
}(_react2.default.Component);

TermsPanel.propTypes = {
  showCheckbox: _propTypes2.default.bool,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.any,
  title: _propTypes2.default.any,
  description: _propTypes2.default.any,
  checkboxId: _propTypes2.default.string
};

exports.default = TermsPanel;


//////////////////
// WEBPACK FOOTER
// ./lib/terms/TermsPanel.js
// module id = 590
// module chunks = 0